import { KennoFile } from '@pandiafi/design-system'

import { useAPIPostFileInit } from 'api/apiHooks/useAPIPostFileInit'
import { useAPIPostFileComplete } from 'api/apiHooks/useAPIPostFileComplete'

export const useUploadFile = (contractUuid: string) => {
  const initFile = useAPIPostFileInit()
  const completeFile = useAPIPostFileComplete()

  const uploadFile = async (file: KennoFile): Promise<KennoFile | null> => {
    try {
      const {
        uuid,
        metadata: { uploadHeaders, uploadUrl },
      } = await initFile.mutateAsync({ file, contractUuid })
      const signal = file._abortController && file._abortController.signal

      await fetch(uploadUrl, {
        headers: uploadHeaders,
        method: 'PUT',
        body: file._originalFile,
        signal,
      })

      const { id, fileName, contentType, fileType, metadata, createdAt } =
        await completeFile.mutateAsync({
          file: { uuid },
        })

      return {
        ...file,
        id,
        uuid,
        fileName,
        contentType,
        fileType,
        metadata,
        createdAt,
      }
    } catch (error) {
      return null
    }
  }

  return uploadFile
}
